"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = exports.UserEndpoints = exports.UserAccountType = exports.PartnerUserState = void 0;
var UserEndpoints;
(function (UserEndpoints) {
    UserEndpoints["CreatePassword"] = "users/create-password";
    UserEndpoints["CreatePasswordFromToken"] = "users/create-password-from-token";
    UserEndpoints["ForgotPassword"] = "/users/forgot-password";
    UserEndpoints["GetPartnerUserState"] = "/users/partners/get-partner-user-state";
    UserEndpoints["GetUser"] = "/users/get-user";
    UserEndpoints["GetAuthCode"] = "/users/get-auth-code";
    UserEndpoints["Logout"] = "/users/log-out";
    UserEndpoints["PreVerifyCreatePassword"] = "/users/pre-verify-create-password";
    UserEndpoints["ResetPassword"] = "/users/reset-password";
    UserEndpoints["PreVerifyBirthdate"] = "/users/pre-verify-birthdate";
    UserEndpoints["PreVerifyMfaCode"] = "/users/pre-verify-mfa-code";
    UserEndpoints["SendEmailVerification"] = "/users/send-email-verification";
    UserEndpoints["SendMfaCode"] = "/users/send-mfa-code";
})(UserEndpoints || (exports.UserEndpoints = UserEndpoints = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["Unspecified"] = "USER_STATUS_UNSPECIFIED";
    UserStatus["NotFound"] = "NOT_FOUND";
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Inactive"] = "INACTIVE";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var UserAccountType;
(function (UserAccountType) {
    UserAccountType["Unspecified"] = "USER_ACCOUNT_TYPE_UNSPECIFIED";
    UserAccountType["Consumer"] = "CONSUMER";
    UserAccountType["Admin"] = "ADMIN";
    UserAccountType["CustomerSupport"] = "CUSTOMER_SUPPORT";
    /** For customers applying through a partner app (sunrise) */
    UserAccountType["Partner"] = "PARTNER";
})(UserAccountType || (exports.UserAccountType = UserAccountType = {}));
/**
 * @todo This enum is a WIP for project Sunrise and subject to change
 */
var PartnerUserState;
(function (PartnerUserState) {
    PartnerUserState["Unspecified"] = "PARTNER_CUSTOMER_STATE_UNSPECIFIED";
    /**
     * Partner user has not yet applied for card.
     * Cardless user does not exist for partner user.
     */
    PartnerUserState["NewUser"] = "NEW_USER";
    /**
     * Partner user applied for and was approved for Cardless card.
     * Cardless user exists for partner user.
     */
    PartnerUserState["Active"] = "ACTIVE";
    /**
     * Partner user applied for and was declined for Cardless card.
     * Cardless user does not exist for partner user.
     */
    PartnerUserState["ApplicationDeclined"] = "APPLICATION_DECLINED";
})(PartnerUserState || (exports.PartnerUserState = PartnerUserState = {}));
